<script>
  export let content = {
    subjectListItems: ['']
  };
</script>

<div class="w-screen flex items-center justify-center bg-no-repeat bg-center bg-cover h-[5.1rem] sm:h-[7.9rem] md:h-[8.3rem] lg:h-[11.4rem] xl:h-[17.1rem] bg-[url('/assets-mkt/routes/home/thin_green_wave_v1_1x.svg')] sm:bg-[url('/assets-mkt/routes/home/thin_green_wave_v1_2x.svg')] md:bg-[url('/assets-mkt/routes/home/thin_green_wave_v1_3x.svg')] lg:bg-[url('/assets-mkt/routes/home/thin_green_wave_v1_4x.svg')] xl:bg-[url('/assets-mkt/routes/home/thin_green_wave_v1_5x.svg')]">
  <ul class="font-poppins w-full flex items-center justify-center gap-[0.5rem] text-white text-[1.1rem] font-semibold mt-[1rem] sm:gap-[2rem] sm:text-[1.8rem] sm:mt-[1.8rem] md:gap-[2rem] md:text-[2.3rem] md:mt-[1.8rem] list-none p-0">
    {#each content.subjectListItems as item, i}
      <li>{item}</li>
      {#if i !== content.subjectListItems.length - 1}
        <li>•</li>
      {/if}
    {/each}
  </ul>
</div>
